import { render, staticRenderFns } from "./ConnectionDetails.vue?vue&type=template&id=df2a18b4&"
import script from "./ConnectionDetails.vue?vue&type=script&lang=ts&"
export * from "./ConnectionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports